import { Link, NavLink } from 'react-router-dom';
import {
    LayoutDashboard,
    Tag,
    Users,
    PenSquare,
    Calendar,
    MessageSquareText,
    Inbox,
    BarChart3,
    Shield,
    Settings,
    FilePen,
    History,
    Terminal,
    KeyRound,
    ChevronLeft,
} from 'lucide-react';
import TESTIDS from '@/constants/testIds';

const NAV_ITEMS = [
    { to: '/admin/social', label: 'Dashboard', Icon: LayoutDashboard, testId: TESTIDS.sidebarDashboard, end: true },
    { to: '/admin/social/brands', label: 'Brands', Icon: Tag, testId: TESTIDS.sidebarBrands },
    { to: '/admin/social/accounts', label: 'Accounts', Icon: Users, testId: TESTIDS.sidebarAccounts },
    { to: '/admin/social/composer', label: 'Composer', Icon: PenSquare, testId: TESTIDS.sidebarComposer },
    { to: '/admin/social/drafts', label: 'Drafts', Icon: FilePen, testId: TESTIDS.sidebarDrafts },
    { to: '/admin/social/calendar', label: 'Calendar', Icon: Calendar, testId: TESTIDS.sidebarCalendar },
    { to: '/admin/social/comments', label: 'Comments', Icon: MessageSquareText, testId: TESTIDS.sidebarComments },
    { to: '/admin/social/inbox', label: 'Inbox (DM)', Icon: Inbox, testId: TESTIDS.sidebarInbox },
    { to: '/admin/social/analytics', label: 'Analytics', Icon: BarChart3, testId: TESTIDS.sidebarAnalytics },
    { to: '/admin/social/automation', label: 'Automation', Icon: Shield, testId: TESTIDS.sidebarAutomation },
    { to: '/admin/social/audit', label: 'Audit Logs', Icon: History, testId: TESTIDS.sidebarAuditLogs },
    { to: '/admin/social/keys', label: 'API Keys', Icon: KeyRound, testId: 'sidebar-api-keys' },
    { to: '/admin/social/settings', label: 'Settings', Icon: Settings, testId: TESTIDS.sidebarSettings },
];

export function Sidebar() {
    return (
        <aside className="hidden h-screen w-64 shrink-0 flex-col border-r border-[hsl(var(--hairline))] bg-[hsl(var(--surface-1))] md:flex">
            <Link
                to="/admin"
                data-testid="social-back-to-admin"
                className="group flex h-14 items-center gap-2 border-b border-[hsl(var(--hairline))] px-4 transition-colors hover:bg-[hsl(var(--surface-2))]"
                title="Back to Admin Console"
            >
                <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[hsl(var(--primary)/0.15)] text-[hsl(var(--primary))] transition-transform group-hover:-translate-x-0.5">
                    <ChevronLeft className="h-4 w-4" />
                </div>
                <div className="min-w-0">
                    <div className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground leading-none">
                        Back to
                    </div>
                    <div className="text-sm font-semibold tracking-tight leading-tight">Admin Console</div>
                </div>
            </Link>
            <div className="flex items-center gap-2 border-b border-[hsl(var(--hairline))] px-4 py-3">
                <div className="flex h-7 w-7 items-center justify-center rounded-md bg-[hsl(var(--primary)/0.15)] text-[hsl(var(--primary))]">
                    <Terminal className="h-3.5 w-3.5" />
                </div>
                <div>
                    <div className="text-sm font-semibold tracking-tight leading-tight">Social Operator</div>
                    <div className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
                        TySoce
                    </div>
                </div>
            </div>
            <nav className="flex flex-1 flex-col gap-0.5 overflow-y-auto p-2">
                {NAV_ITEMS.map(({ to, label, Icon, testId, end }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={end}
                        data-testid={testId}
                        className={({ isActive }) =>
                            `flex items-center gap-2 rounded-md px-3 py-2 text-[13px] transition-colors duration-150 ${
                                isActive
                                    ? 'bg-[hsl(var(--surface-3))] text-foreground'
                                    : 'text-muted-foreground hover:bg-[hsl(var(--surface-2))] hover:text-foreground'
                            }`
                        }
                    >
                        <Icon className="h-4 w-4 opacity-80" />
                        <span>{label}</span>
                    </NavLink>
                ))}
            </nav>
            <div className="border-t border-[hsl(var(--hairline))] p-3">
                <Link
                    to="/admin/social/keys"
                    className="block rounded-md border border-dashed border-border bg-[hsl(var(--surface-2))] p-2 text-[11px] text-muted-foreground transition-colors hover:border-[hsl(var(--primary)/0.4)] hover:text-foreground"
                    data-testid="sidebar-meta-status-link"
                >
                    <div className="font-mono uppercase tracking-wider">meta integration</div>
                    <div>Placeholder mode — paste credentials in API Keys.</div>
                </Link>
            </div>
        </aside>
    );
}
